module.exports = __webpack_public_path__ + "img/s2_stepimg03.d7528447.png";